module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1522-49b3f1eb2e8e141e0bbc9d899229f180.png";